import * as yup from "yup";
const phoneRegExp = /^[6-9]\d{9}$/;
const landlineRegExp = /^0\d{2,4}-?\d{6,8}$/;
export const ContactFormConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "name",
        label: "contactformLabels.name",
        type: "input",
        mandatory: "true",
      },
      {
        name: "email",
        label: "contactformLabels.email",
        maxLength: "30",
        type: "input",
      },
      {
        name: "phone1",
        label: "contactformLabels.phone1",
        type: "input",
        mandatory: "true",
      },
      {
        name: "phone2",
        label: "contactformLabels.phone2",
        type: "input",
      },
      {
        name: "all_banks",
        label: "contactformLabels.allbanks",
        type: "select",
        options: [],
        mandatory: "true",
      },
      {
        name: "all_branches",
        label: "contactformLabels.allbranches",
        type: "select",
        options: [],
        mandatory: "true",
      },
      {
        name: "agency_id",
        label: "contactformLabels.agency",
        type: "select",
        mandatory: "true",
      },
      // {
      //   name: "type",
      //   label: "Contact Type",
      //   type: "select",
      //   options: [{ value: "External", label: "External" }],
      // },
      {
        name: "region",
        label: "contactformLabels.region",
        type: "hier_select",
        mandatory: "true",
      },
      {
        name: "job_title_id",
        label: "contactformLabels.jobtitle",
        type: "select",
        mandatory: "true",
      },
      {
        name: "contact_type",
        label: "contactformLabels.contact",
        type: "select",
        mandatory: "true",
        options: [
          { value: "Contractual", label: "Contractual" },
          { value: "Permanent", label: "Permanent" },
        ],
      },

      // {
      //   name: "quantity",
      //   label: "contactformLabels.quantity",
      //   type: "input",
      //   disabled: false,
      // },
      {
        name: "skills",
        label: "contactformLabels.skills",
        type: "text_area",
        // options: [],
      },
      {
        name: "address",
        label: "contactformLabels.address",
        type: "text_area",
      },
    ],
  },
];

export const contactTableData = [];

export const userTableDatacolumnsForExport = [
  { label: "Name", key: "full_name" },
  { label: "Username", key: "user_name" },
  { label: "Phone", key: "phone_number" },
  { label: "Secondary Phone", key: "secondary_phone_number" },
  { label: "Created On", key: "createdOn" },
  { label: "Department", key: "department" },
  { label: "User Level", key: "userLevel" },
  { label: "Bank Name", key: "bankName" },
  { label: "Branch Name", key: "branchName" },
  { label: "Role", key: "user_role_map" },
  { label: "Job Title", key: "jobTitleName" },
  { label: "Address", key: "address" },
  // { label: "Email", key: "email" },
];

export const userActivityTableDataForExport = [
  { label: "Date", key: "date" },
  { label: "Name", key: "name" },
  { label: "User Name", key: "user_name" },
  { label: "Phone", key: "phone_number" },
  { label: "Role", key: "role" },
  { label: "Agency", key: "agency" },
  { label: "Activity", key: "activity" },
  { label: "Detail", key: "detail" },
  // {label: "User Region", key: "user_region"},
  { label: "Job Title", key: "job_title" },
  { label: "Time", key: "time" },
  // {label: "Ip Address", key: "ip_address"}
];

export const contactformschema = [
  yup.object({
    // name: yup.string().required("Please provide the name"),
    name: yup
      .string()
      .required("Please Provide the Contact Name")
      .trim() // Removes any leading and trailing whitespace
      .matches(
        /^[A-Za-z0-9\s]+$/,
        "Contact Name should only contain letters, numbers, and spaces"
      ),
    phone1: yup
      .string()
      .required("Please provide the Mobile/Landline Number 1")
      .test(
        "is-valid-phone",
        "Enter a valid Mobile/Landline Number 1 (e.g., 9876543210 or 011-23456789)",
        (value) => phoneRegExp.test(value) || landlineRegExp.test(value)
      ),
    all_banks: yup.string().required("Bank Name is required"),
    all_branches: yup.string().required("Branch Name is required"),

    job_title_id: yup.string().required("Job Title is required"),
    region: yup
      .array()
      .test("region-validation", "Region is required", function (value) {
        // Skip validation if in edit mode and we have existing regions
        if (this.parent.id && this.parent.contact_region_map?.length > 0) {
          return true;
        }
        return value?.length > 0;
      }),
    phone2: yup
      .string()
      .nullable() // Allow null values (empty string)
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      ) // Transform an empty string to null
      .test(
        "is-valid-phone",
        "Please Provide a valid phone number",
        (value) => value === null || /^(?:\+91|0)?[6789]\d{9}$/.test(value)
      )
      .max(15, "Phone number must be at most 15 digits"),

    email: yup
      .string()
      .nullable()
      .transform(
        (value, originalValue) =>
          originalValue === "" ? null : originalValue.toLowerCase() // Convert to lowercase
      )
      .test(
        "is-valid-email",
        "Please provide a valid Email Address",
        (value) => value === null || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      ),
    agency_id: yup.string().required("Please select the Agency"),

    contact_type: yup.string().required("Please select the Contact Type"),

    quantity: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .when("contactType", {
        is: "Team", // Validation applies only if contactType is "Team"
        then: yup
          .number()
          .nullable()
          .transform((value, originalValue) =>
            originalValue === "" ? null : value
          )
          .test(
            "is-valid-number",
            "Please provide a valid number",
            (value) => value === null || !isNaN(value)
          )
          .typeError("Please provide a valid number"),
        otherwise: yup.number().nullable(), // No validation for "Individual"
      }),

    address: yup
      .string()
      .nullable() // Allow null values (empty string)
      .max(200, "Description must be atmost 200 characters"),
  }),
];

export const contactcolumnsForExport = [
  { label: "Name", key: "name" },
  { label: "Job Title", key: "job_title" },
  { label: "Phone1", key: "phone1" },
  { label: "Email", key: "email" },
  { label: "Bank", key: "bank_name" },
  { label: "Address", key: "address" },
  { label: "Region", key: "region_name" },
  { label: "Agency Name", key: "agency_name" },
  { label: "Type", key: "type" },
  { label: "Skill", key: "skills" },
  { label: "Created On", key: "created_on" },
  { label: "Updated By", key: "updated_by" },
];

// export const contactcolumnsForExport = [
//   { label: "Name", key: "Name" },
//   {label: "Job Title", key: "Job Title"},
//   { label: "Phone1", key: "Phone1" },
//   { label: "Email", key: "Email" },
//   { label: "Address", key: "Address" },
//   { label: "Region", key: "Region" },
//   { label: "Agency Name", key: "Agency Name" },
//   { label: "Skill", key: "Skill" },
// ];
